import Media from "react-media";
import styled from "styled-components";
import { Redirect } from 'react-router-dom';
import React, { Component } from 'react';
import { Image, Header, Divider } from 'semantic-ui-react';

import Footer from '../../components/Footer/Footer';
import LoginForm from "./LoginForm";
import ForgetForm from './ForgetForm';
import { UserContext } from "../../context";
import { BACKGROUND, BACKGROUND_MINI, SEKOLAH_LOGO, SEKOLAH_NAMA, THEME_COLOR } from "../../config";

const Layout = styled.div`
	position: relative;
	background: url(${BACKGROUND}) no-repeat center center fixed;
	min-width: 100%;
	min-height: 100vh;
	display: grid;
	grid-template-columns: 1fr 1fr;
	background-size: cover;

	@media only screen and (max-width: 768px) {
		background: url(${BACKGROUND_MINI}) no-repeat center center fixed;
		background-size: cover;
		grid-template-rows: auto 1fr auto;
		grid-template-columns: 1fr;
		grid-gap: 1em;
		position: relative;
		padding: 1em
	}
`

const Left = styled.div`
	diplay: flex;
	flex-direction: row;
	color: white;
	max-width: 400px;
	align-self: center;
	justify-self: center;
	@media only screen and (max-width: 768px) {
	}

`
const Right = styled.div`
	diplay: flex;
	flex-direction: row;
	color: white;
	justify-self: center;
	align-self: center;

	@media only screen and (max-width: 768px) {
		max-width: 400px;
	}
`

const MainHolder = styled.div`
	display: flex;
	padding: 1.5rem;
	padding-top: 2rem;
	padding-bottom: 2rem;
  background-color: white;
	border-radius: 6px;
	flex-direction: column;
	position: responsive;

	@media only screen and (max-width: 768px) {
		padding-top: 1.5rem;
		padding-bottom: 1.5rem;
	}
`

const Brand = styled.div`
	display: flex;
	position: absolute;
	bottom: 2em;
	left: 2em;
	flex-direction: row;
	align-items: flex-end;
	@media only screen and (max-width: 768px) {
		position: relative;
		bottom: 0;
		left: 0;
	}
`

const DEFAULT_TITLE = "Impuls Computer Based Test"
class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: "LOGIN"
		}

		this.handleStatus = this.handleStatus.bind(this)
	}

	handleStatus(value){
		this.setState({status: (value || "")});
	}
	
	render() {
		const { status } = this.state
		const { is_login } = this.context
		const {redirection} = this.props
		document.title = DEFAULT_TITLE

		if (is_login) { return <Redirect to={redirection !== ''?decodeURIComponent(redirection):'/profil'} />; }
		return (<Layout>
			<Media query={{ maxWidth: 768 }}>
				{v => v
					? <>
						<Left style={{paddingTop: "4em"}}>
							<h2 style={{margin: 0}}>Selamat datang di</h2>
							<h1 style={{margin: 0}}>Aplikasi Ujian Daring</h1>
						</Left>
						<Right>
							<MainHolder>
								<Image size="tiny" src={SEKOLAH_LOGO} />
								<Header as="h2" style={{color: THEME_COLOR}}>{SEKOLAH_NAMA}</Header>
								<Divider />
								{status === "LOGIN" && <LoginForm redirection={redirection} setStatus={this.handleStatus}/>}
								{status === "FORGET" && <ForgetForm setStatus={this.handleStatus}/>}
							</MainHolder>
						</Right>
						<Brand>
							<Footer fontSize=".65em" widthImage="36" fontColor="white" paddingContainer="0"/>
						</Brand>
					</>
					: <>
					<Left>
						<h2 style={{margin: 0}}>Selamat datang di</h2>
						<h1 style={{margin: 0}}>Aplikasi Ujian Daring</h1>
						<Brand>
							<Footer fontSize=".65em" widthImage={36} fontColor="white" paddingContainer="0"/>
						</Brand>
					</Left>
					<Right style={{width: "360px"}}>
						<MainHolder>
							<Image size="tiny" src={SEKOLAH_LOGO} />
							<Header as="h2" style={{color: THEME_COLOR}}>{SEKOLAH_NAMA}</Header>
							<Divider />
							{status === "LOGIN" && <LoginForm redirection={redirection} setStatus={this.handleStatus}/>}
							{status === "FORGET" && <ForgetForm setStatus={this.handleStatus}/>}
						</MainHolder>
					</Right>
					</>
				}
			</Media>
		</Layout>);
	}
}

Login.contextType = UserContext;

export default Login;